export const STATS = ['strength', 'defence', 'speed', 'dexterity'] as const;
export type Stat = (typeof STATS)[number];

export const DISCIPLINES = ['martial', 'craft', 'cunning', 'cloister'] as const;
export type Discipline = (typeof DISCIPLINES)[number];

export const SKILLS = [
  'archery', 'jousting', 'horsemanship', 'hunting',
  'mining', 'woodcutting', 'smithing', 'engineering',
  'lockpicking', 'gambling', 'cardSharping', 'haggling',
  'alchemy', 'illumination', 'brewing', 'fishing',
] as const;
export type SkillId = (typeof SKILLS)[number];

export const CALLINGS = ['knight', 'ranger', 'rogue', 'artisan', 'cloistered', 'merchant'] as const;
export type CallingId = (typeof CALLINGS)[number];

export const TOWNS = ['wynchester', 'millrace', 'ironhold', 'thornwood'] as const;
export type TownId = (typeof TOWNS)[number];

export const QUALITIES = ['crude', 'common', 'fine', 'superior', 'masterwork'] as const;
export type Quality = (typeof QUALITIES)[number];

/** Where gear is worn or wielded. The first three are weapon slots; fists need none. A mount is ridden into a fight. */
export const GEAR_SLOTS = ['mainHand', 'offHand', 'ranged', 'head', 'body', 'hands', 'legs', 'feet', 'mount'] as const;
export type GearSlot = (typeof GEAR_SLOTS)[number];
export const WEAPON_SLOTS = ['mainHand', 'offHand', 'ranged'] as const satisfies readonly GearSlot[];
export type WeaponSlot = (typeof WEAPON_SLOTS)[number];
/** The five pieces of a full set of armour. Their armour adds up, to the cap in balance.fight. */
export const ARMOUR_SLOTS = ['head', 'body', 'hands', 'legs', 'feet'] as const satisfies readonly GearSlot[];
export type ArmourSlot = (typeof ARMOUR_SLOTS)[number];

/** Bars a consumable can top up. Life is restored as a fraction of max; these by a flat amount. */
export const BOOST_BARS = ['vigour', 'focus', 'nerve', 'mood'] as const;
export type BoostBar = (typeof BOOST_BARS)[number];

/** Consumables in one group share a cooldown: one draught, or one feast, at a time. */
export const COOLDOWN_GROUPS = ['draught', 'feast', 'meal'] as const;
export type CooldownGroup = (typeof COOLDOWN_GROUPS)[number];

/** Lifetime counts on a player's record (game-core's `applyProgress` keeps them). Deeds test them. */
export const COUNTERS = [
  /** Minigames finished (abandoned ones don't count). */
  'games',
  /** Masterwork goods made, at a venue or from a recipe. */
  'masterworks',
  /** Fights won and lost, as attacker or defender. */
  'fightsWon',
  'fightsLost',
  /** How fights won as the attacker ended. */
  'spares',
  'robs',
  'maims',
  /** Crimes attempted, and how many ended in gaol. */
  'crimes',
  'crimesCaught',
  /** Coin won over the stake at the tables (the Dice Cellar, the Black Dog). */
  'tableCoin',
  /** Trades with other players, and market orders filled. */
  'trades',
  /** Feats done, all engines together. */
  'feats',
] as const;
export type Counter = (typeof COUNTERS)[number];

/** The first-steps chain, in the order it is shown (game-core's `FIRST_STEPS` says what does each). */
export const FIRST_STEP_KEYS = ['train', 'venue', 'shop', 'road', 'trade', 'fight', 'bank'] as const;
export type FirstStepKey = (typeof FIRST_STEP_KEYS)[number];
